import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, UserFullDTO } from '../../../../services/api/api';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { ErrorService } from '../../../../services/error.service';
import { SbDateTime, SbLocalDateTime } from '../../../../services/api/api-date-time';
import { RestoreUser } from '../admin-user-management.component';
import { UtilService } from '../../../../services/util.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-admin-user-set-restore-code',
  templateUrl: './admin-user-set-restore-code.component.html',
  styleUrls: ['./admin-user-set-restore-code.component.scss'],
  standalone: false,
})
export class AdminUserSetRestoreCodeComponent implements OnInit {
  user: UserFullDTO;
  restoreCode: string | null;

  constructor(
    public readonly util: UtilService,
    private readonly api: API,
    private readonly modalNavigation: ModalNavigationService,
    private readonly errorhandler: ErrorService,
    private readonly destroyRef: DestroyRef
  ) {}

  _till?: SbDateTime;

  get till(): SbDateTime {
    return this._till;
  }

  set till(val: SbDateTime) {
    this._till = val;
  }

  ngOnInit(): void {
    this.user = this.modalNavigation.getCurrentNavigation().data?.user;
  }

  onRestoreCode($event: string) {
    if ($event?.length > 0) {
      this.restoreCode = $event;
    } else {
      this.restoreCode = null;
    }
  }

  ok() {
    if (this.user && this.restoreCode?.length >= 8) {
      this.api
        ._admin_User_setRestoreCode(this.restoreCode, this.user, { validTill: this.till ? this.till : null })
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: () => {
            const restoreUser: RestoreUser = {
              user: this.user,
              restoreCode: this.restoreCode,
            };
            this.modalNavigation.result(restoreUser);
          },
          error: error => {
            this.errorhandler.errorHandler(error);
          },
        });
    }
  }

  changeTill(e: SbLocalDateTime) {
    this.till = new SbDateTime(e.value);
  }

  close() {
    this.modalNavigation.result(null);
  }

  cancel() {
    this.close();
  }
}
